import Snackbar from '@mui/material/Snackbar';
import { CSSProperties, ReactNode } from 'react';
import AgAlert from '../AgAlert';

export interface AgToastProps {
  open: boolean;
  severity: 'success' | 'error' | 'neutral';
  message: string | ReactNode;
  time?: number;
  temporary?: boolean;
  style?: CSSProperties | undefined;
  onIconClick?: () => void;
}

const AgToast = (
  {
    open,
    severity = 'success',
    message,
    time = 5000,
    temporary = false,
    style,
    onIconClick
  }: AgToastProps) => {
  return (
    <Snackbar
      open={open}
      message={<AgAlert severity={severity} message={message} temporary={temporary} onIconClick={onIconClick} />}
      autoHideDuration={temporary ? time : null}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      onClose={() => temporary && onIconClick && onIconClick()}
      sx={{
        '& .MuiSnackbarContent-root': {
          padding: '0',
          width: 'max-content',
          boxShadow: 'none'
        },
        '& .MuiSnackbarContent-message': {
          padding: 0,
          wordWrap: 'break-word',
          width: '100%'
        }
      }}
      style={style}
    />
  );
};

export default AgToast;